module.exports = __webpack_public_path__ + "static/media/ebo-logo.4c09a7ac.png";